import Konva from 'konva'
import { referenceLineSet } from '@ps/types/workbench/stage.type'

interface StageState {
  stage: Konva.Stage | null
  layer: Konva.Layer | null
  rulerLayer: Konva.Layer | null
  transformer: Konva.Transformer | null
  selectionRectangle: Konva.Rect | null
  referenceLineSets: referenceLineSet[]
  activationShape: Konva.Rect[] // 激活的节点，只有 group 节点双击才会激活
  selectedShape: {
    [key: string]: Konva.Rect // 当前选中的节点，key 为原有的 zIndex，value 为当前选中的节点
  }
}

const StageData: StageState = {
  stage: null,
  layer: null,
  rulerLayer: null,
  transformer: null,
  selectionRectangle: null,
  referenceLineSets: [],
  activationShape: [],
  selectedShape: {},
}

// @ts-ignore
window.StageData = StageData

export default StageData
